import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Truncated } from '@frontend/design-system';
import { CompactTableExpandRowButton, CompactTableRowActions, CompactTableSelectRow } from '.';

export const CompactTableRowHeader = ({ title }: { title: ReactNode | undefined }) => {
  return (
    <div css={[styles.flexRow, styles.rowElement]}>
      <div css={styles.displayNameContainer}>
        <CompactTableSelectRow />
        {title && (typeof title === 'string' ? <Truncated css={styles.displayName}>{title}</Truncated> : title)}
      </div>
      <div css={styles.rowActions}>
        <CompactTableRowActions />
        <CompactTableExpandRowButton />
      </div>
    </div>
  );
};

const styles = {
  flexRow: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.spacing(1)};
  `,
  rowElement: css``,
  displayNameContainer: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(3)};
  `,
  displayName: css`
    max-width: 176px;
    font-weight: ${theme.font.weight.bold};
  `,
  rowActions: css`
    display: flex;
    gap: ${theme.spacing(1)};
  `,
};
